import { render } from "./BackButton.vue?vue&type=template&id=c824f994"
import script from "./BackButton.vue?vue&type=script&setup=true&lang=js"
export * from "./BackButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Atoms/BackButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c824f994"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c824f994', __exports__)) {
    api.reload('c824f994', __exports__)
  }
  
  module.hot.accept("./BackButton.vue?vue&type=template&id=c824f994", () => {
    api.rerender('c824f994', render)
  })

}


export default __exports__